import React, { useEffect, useState , useMemo} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Snackbar, Backdrop, ThemeProvider, createTheme, CssBaseline} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import LoginForm from "./pages/LoginForm";
import HomePage from "./pages/HomePage";

export default function App() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  const isDark = localStorage.getItem("saved_theme_id") === "2";

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
  }, [isDark]);

  useEffect(() => {
    const handleSWUpdate = (event) => {
      const registration = event.detail;
      setNewVersionAvailable(true);
      setWaitingWorker(registration.waiting || registration.installing);
    };

    window.addEventListener("swUpdated", handleSWUpdate);
    return () => window.removeEventListener("swUpdated", handleSWUpdate);
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      waitingWorker.addEventListener("statechange", (e) => {
        if (e.target.state === "activated") {
          window.location.reload();
        }
      });
    }
  };

  useEffect(() => {
    if (newVersionAvailable) {
      handleUpdate();
    }
  }, [newVersionAvailable]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/home/*" element={<HomePage />} />
        </Routes>

        <Backdrop
          open={newVersionAvailable}
          sx={{ zIndex: 1300, color: "#fff" }}
        />

        <Snackbar
          open={newVersionAvailable}
          message="Updating to the latest version..."
          autoHideDuration={5000}
          onClose={() => setNewVersionAvailable(false)}
        />
      </Router>
    </LocalizationProvider>
    
  );
}